import React from 'react';
import { useLanguage } from './LanguageContext';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Legal = () => {
  const { language } = useLanguage();
  const { page } = useParams();

  const content = {
    de: {
      imprint: {
        title: "Impressum",
        content: (
          <>
            <p className="mb-4 font-semibold">Angaben gemäß § 5 DDG:</p>
            
            <p className="mb-6">
              <strong>Anbieter:</strong><br />
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nürnberg<br />
              Deutschland
            </p>

            <p className="mb-6">
              <strong>Kontakt:</strong><br />
              Telefon: +49 (0) 151 27110726<br />
              E-Mail: leopold.brosig@bcre8ive.de
            </p>

            <p className="mb-6">
              <strong>Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:</strong><br />
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nürnberg
            </p>

            <p className="mb-6 text-sm">
              <strong>Hinweis:</strong> Die E-Mail-Adresse ermöglicht eine direkte Kontaktaufnahme. 
              Diese Website unterliegt dem deutschen Recht.
            </p>
          </>
        )
      },
      privacy: {
        title: "Datenschutzerklärung",
        content: (
          <>
            <h2 className="text-2xl mb-4 mt-8">1. Verantwortlicher und Datenschutzbeauftragter</h2>
            
            <h3 className="text-xl mb-3 mt-6">Verantwortlicher im Sinne der DSGVO und des TDDDG</h3>
            <p className="mb-4">
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
              <strong>Leopold Maximilian Brosig</strong><br />
              Schildgasse 27<br />
              90403 Nürnberg<br />
              Deutschland<br />
              E-Mail: leopold.brosig@bcre8ive.de<br />
              Telefon: +49 (0) 151 27110726
            </p>

            <h2 className="text-2xl mb-4 mt-8">2. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-xl mb-3 mt-6">Allgemeine Hinweise</h3>
            <p className="mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 className="text-xl mb-3">Datenerfassung auf dieser Website</h3>
            <h4 className="text-lg mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p className="mb-4">Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Verantwortlicher" in dieser Datenschutzerklärung entnehmen.</p>

            <h4 className="text-lg mb-2">Wie erfassen wir Ihre Daten?</h4>
            <p className="mb-4">
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder per E-Mail/Telefon übermitteln.
            </p>
            <p className="mb-6">
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <h4 className="text-lg mb-2">Wofür nutzen wir Ihre Daten?</h4>
            <p className="mb-4">Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>

            <h4 className="text-lg mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p className="mb-6">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem steht Ihnen das Recht zu, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>

            <h2 className="text-2xl mb-4 mt-8">3. Hosting</h2>
            <p className="mb-4">
              Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
            <p className="mb-4">
              Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
            <p className="mb-6">
              Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
            </p>

            <h2 className="text-2xl mb-4 mt-8">4. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="text-xl mb-3 mt-6">Datenschutz</h3>
            <p className="mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzbestimmungen sowie dieser Datenschutzerklärung.
            </p>
            <p className="mb-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>
            <p className="mb-6">
              Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
            </p>

            <h3 className="text-xl mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p className="mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <p className="mb-6">
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nürnberg<br />
              Deutschland<br />
              <br />
              Telefon: +49 (0) 151 27110726<br />
              E-Mail: leopold.brosig@bcre8ive.de
            </p>

            <h3 className="text-xl mb-3">Speicherdauer</h3>
            <p className="mb-6">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
            </p>

            <h3 className="text-xl mb-3">Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</h3>
            <p className="mb-4">
              Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO.
            </p>
            <p className="mb-4">
              Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO.
            </p>
            <p className="mb-6">
              Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser Datenschutzerklärung informiert.
            </p>

            <h2 className="text-2xl mb-4 mt-8">5. Kontaktaufnahme</h2>
            
            <h3 className="text-xl mb-3">Kontakt per E-Mail, Telefon oder Fax</h3>
            <p className="mb-4">
              Wenn Sie uns per E-Mail, Telefon oder Fax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mb-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), sofern diese abgefragt wurde.
            </p>
            <p className="mb-6">
              Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
            </p>

            <h2 className="text-2xl mb-4 mt-8">6. Cookies und Tracking-Technologien</h2>
            
            <h3 className="text-xl mb-3 mt-6">Allgemeine Hinweise zu Cookies</h3>
            <p className="mb-4">
              Diese Website verwendet Cookies. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (dauerhafte Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Dauerhafte Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
            </p>
            <p className="mb-4">
              Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die Nutzung bestimmter Dienstleistungen des Drittunternehmens (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
            </p>
            <p className="mb-6">
              Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren würden (z. B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies können zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden.
            </p>

            <h3 className="text-xl mb-3">Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z. B. für die Warenkorbfunktion) oder zur Optimierung der Website (z. B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird.</h3>
            <p className="mb-4">
              Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit widerrufbar.
            </p>
            <p className="mb-6">
              Sie können Ihre Einwilligung jederzeit über unsere Cookie-Einstellungen oder direkt hier widerrufen. Die Datenverarbeitung, die bis zum Widerruf erfolgt ist, bleibt von dem Widerruf unberührt.
            </p>

            <h3 className="text-xl mb-3">Server-Log-Dateien</h3>
            <p className="mb-4">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="mb-6">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
            </p>

            <h2 className="text-2xl mb-4 mt-8">7. Datenübertragung in Drittländer</h2>
            <p className="mb-4">
              Sofern wir Daten in Drittländer (d. h. Länder außerhalb der Europäischen Union (EU), des Europäischen Wirtschaftsraums (EWR)) übermitteln oder die Übermittlung im Rahmen der Inanspruchnahme von Diensten Dritter oder der Offenlegung bzw. Übermittlung von Daten an Dritte erfolgt, erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht.
            </p>
            <p className="mb-6">
              Vorbehaltlich ausdrücklicher Einwilligung oder vertraglich erforderlicher Übermittlung verarbeiten oder lassen wir die Daten nur in Drittländern mit einem anerkannten Datenschutzniveau, vertraglicher Verpflichtung durch sogenannte Standardvertragsklauseln der EU-Kommission, beim Vorliegen von Zertifizierungen oder verbindlichen internen Datenschutzvorschriften verarbeiten.
            </p>

            <h2 className="text-2xl mb-4 mt-8">8. Ihre Rechte</h2>
            <p className="mb-4">Sie haben jederzeit das Recht:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>
                <strong>Auskunft</strong> über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO). Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft Ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen Informationen zu deren Einzelheiten verlangen.
              </li>
              <li>
                <strong>Berichtigung</strong> unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten Daten zu verlangen (Art. 16 DSGVO).
              </li>
              <li>
                <strong>Löschung</strong> Ihrer bei uns gespeicherten Daten zu verlangen, soweit nicht gesetzliche Aufbewahrungspflichten oder Rechtsgrundlagen zur Speicherung der Daten entgegenstehen (Art. 17 DSGVO).
              </li>
              <li>
                <strong>Einschränkung der Verarbeitung</strong> Ihrer personenbezogenen Daten zu verlangen (Art. 18 DSGVO), soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung eingelegt haben.
              </li>
              <li>
                <strong>Datenübertragbarkeit</strong>, sofern wir Ihre Daten auf Grundlage einer Einwilligung oder eines Vertrags automatisiert verarbeiten (Art. 20 DSGVO). Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.
              </li>
              <li>
                <strong>Widerspruch</strong> gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dies auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO geschieht und es Gründe gibt, die sich aus Ihrer besonderen Situation ergeben (Art. 21 DSGVO). Werden personenbezogene Daten von uns verarbeitet, um Direktwerbung zu betreiben, so können Sie jederzeit Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten zum Zwecke derartiger Werbung einlegen.
              </li>
              <li>
                <strong>Widerruf Ihrer Einwilligung</strong> gegenüber uns zu erklären (Art. 7 Abs. 3 DSGVO). Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr fortführen dürfen.
              </li>
              <li>
                <strong>Beschwerde</strong> bei einer Aufsichtsbehörde einzulegen, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt (Art. 77 DSGVO).
              </li>
            </ul>

            <h3 className="text-xl mb-3 mt-6">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="mb-6">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-xl mb-3">Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)</h3>
            <p className="mb-4">
              WERDEN DIE PERSONENBEZOGENEN DATEN AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO VERARBEITET, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING.
            </p>
            <p className="mb-4">
              WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENEN DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT.
            </p>
            <p className="mb-6">
              Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so wird die Verarbeitung der personenbezogenen Daten für diese Zwecke unterbleiben.
            </p>

            <h2 className="text-2xl mb-4 mt-8">9. Technische und organisatorische Maßnahmen</h2>
            <p className="mb-4">
              Wir setzen technische und organisatorische Maßnahmen ein, um Ihre personenbezogenen Daten gegen Verlust, Zerstörung, Manipulation und unberechtigten Zugriff zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung kontinuierlich verbessert.
            </p>
            <p className="mb-6">
              Zu diesen Maßnahmen gehören insbesondere die Verschlüsselung Ihrer Daten mittels SSL/TLS, Zugriffsbeschränkungen, regelmäßige Backups sowie die Schulung unserer Mitarbeiter im Umgang mit personenbezogenen Daten.
            </p>

            <h2 className="text-2xl mb-4 mt-8">10. Änderungen dieser Datenschutzerklärung</h2>
            <p className="mb-6">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>

            <p className="mt-8 text-sm border-t pt-4">
              <strong>Stand dieser Datenschutzerklärung:</strong> Januar 2026<br />
              Diese Datenschutzerklärung entspricht den Anforderungen der DSGVO, des BDSG, des TDDDG sowie den aktuellen gesetzlichen Bestimmungen.
            </p>
          </>
        )
      }
    },
    en: {
      imprint: {
        title: "Legal Notice",
        content: (
          <>
            <p className="mb-4 font-semibold">Information according to § 5 DDG:</p>
            
            <p className="mb-6">
              <strong>Provider:</strong><br />
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nuremberg<br />
              Germany
            </p>

            <p className="mb-6">
              <strong>Contact:</strong><br />
              Phone: +49 (0) 151 27110726<br />
              Email: leopold.brosig@bcre8ive.de
            </p>

            <p className="mb-6">
              <strong>Responsible for content according to § 55 Abs. 2 RStV:</strong><br />
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nuremberg
            </p>

            <p className="mb-6 text-sm">
              <strong>Note:</strong> The email address allows direct contact. 
              This website is subject to German law.
            </p>
          </>
        )
      },
      privacy: {
        title: "Privacy Policy",
        content: (
          <>
            <h2 className="text-2xl mb-4 mt-8">1. Controller and Data Protection Officer</h2>
            
            <h3 className="text-xl mb-3 mt-6">Controller in accordance with GDPR and TDDDG</h3>
            <p className="mb-4">
              The controller responsible for data processing on this website is:<br />
              <strong>Leopold Maximilian Brosig</strong><br />
              Schildgasse 27<br />
              90403 Nuremberg<br />
              Germany<br />
              Email: leopold.brosig@bcre8ive.de<br />
              Phone: +49 (0) 151 27110726
            </p>

            <h2 className="text-2xl mb-4 mt-8">2. Privacy at a Glance</h2>
            
            <h3 className="text-xl mb-3 mt-6">General Information</h3>
            <p className="mb-4">
              The following notes provide a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to personally identify you. Detailed information on the subject of data protection can be found in our privacy policy below.
            </p>

            <h3 className="text-xl mb-3">Data Collection on This Website</h3>
            <h4 className="text-lg mb-2">Who is responsible for data collection on this website?</h4>
            <p className="mb-4">Data processing on this website is carried out by the website operator. You can find their contact details in the "Controller" section of this privacy policy.</p>

            <h4 className="text-lg mb-2">How do we collect your data?</h4>
            <p className="mb-4">
              On the one hand, your data is collected by you providing it to us. This can be, for example, data that you enter in a contact form or transmit by email/phone.
            </p>
            <p className="mb-6">
              Other data is collected automatically or after your consent when visiting the website by our IT systems. This is mainly technical data (e.g., internet browser, operating system, or time of page access). This data is collected automatically as soon as you enter this website.
            </p>

            <h4 className="text-lg mb-2">What do we use your data for?</h4>
            <p className="mb-4">Part of the data is collected to ensure error-free provision of the website. Other data may be used to analyze your user behavior.</p>

            <h4 className="text-lg mb-2">What rights do you have regarding your data?</h4>
            <p className="mb-6">
              You have the right to receive information free of charge at any time about the origin, recipient, and purpose of your stored personal data. You also have the right to request the correction or deletion of this data. If you have given consent to data processing, you can revoke this consent at any time for the future. You also have the right to request the restriction of processing of your personal data under certain circumstances. Furthermore, you have the right to file a complaint with the competent supervisory authority.
            </p>

            <h2 className="text-2xl mb-4 mt-8">3. Hosting</h2>
            <p className="mb-4">
              This website is hosted by an external service provider (hoster). The personal data collected on this website is stored on the hoster's servers. This may include IP addresses, contact requests, meta and communication data, contract data, contact details, names, website access, and other data generated via a website.
            </p>
            <p className="mb-4">
              The hoster is used for the purpose of contract fulfillment towards our potential and existing customers (Art. 6 para. 1 lit. b GDPR) and in the interest of a secure, fast, and efficient provision of our online offer by a professional provider (Art. 6 para. 1 lit. f GDPR).
            </p>
            <p className="mb-6">
              Our hoster will only process your data to the extent necessary to fulfill its performance obligations and will follow our instructions regarding this data.
            </p>

            <h2 className="text-2xl mb-4 mt-8">4. General Information and Mandatory Information</h2>
            
            <h3 className="text-xl mb-3 mt-6">Data Protection</h3>
            <p className="mb-4">
              The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the statutory data protection regulations and this privacy policy.
            </p>
            <p className="mb-4">
              When you use this website, various personal data is collected. Personal data is data with which you can be personally identified. This privacy policy explains what data we collect and what we use it for. It also explains how and for what purpose this happens.
            </p>
            <p className="mb-6">
              We point out that data transmission on the Internet (e.g., when communicating by email) can have security gaps. Complete protection of data against access by third parties is not possible.
            </p>

            <h3 className="text-xl mb-3">Note on the Responsible Party</h3>
            <p className="mb-4">
              The party responsible for data processing on this website is:
            </p>
            <p className="mb-6">
              Leopold Maximilian Brosig<br />
              Schildgasse 27<br />
              90403 Nuremberg<br />
              Germany<br />
              <br />
              Phone: +49 (0) 151 27110726<br />
              Email: leopold.brosig@bcre8ive.de
            </p>

            <h3 className="text-xl mb-3">Storage Period</h3>
            <p className="mb-6">
              Unless a more specific storage period has been specified within this privacy policy, your personal data will remain with us until the purpose for data processing no longer applies. If you assert a justified request for deletion or revoke consent for data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data (e.g., tax or commercial law retention periods); in the latter case, deletion will take place after these reasons no longer apply.
            </p>

            <h3 className="text-xl mb-3">General Information on the Legal Basis for Data Processing on This Website</h3>
            <p className="mb-4">
              If you have consented to data processing, we process your personal data on the basis of Art. 6 para. 1 lit. a GDPR or Art. 9 para. 2 lit. a GDPR, if special categories of data are processed according to Art. 9 para. 1 GDPR. In the case of explicit consent to the transfer of personal data to third countries, data processing is also carried out on the basis of Art. 49 para. 1 lit. a GDPR.
            </p>
            <p className="mb-4">
              If you have consented to the storage of cookies or to the access to information on your end device (e.g., via device fingerprinting), data processing is also carried out on the basis of § 25 para. 1 TDDDG. Consent can be revoked at any time. If your data is required for contract fulfillment or for the implementation of pre-contractual measures, we process your data on the basis of Art. 6 para. 1 lit. b GDPR.
            </p>
            <p className="mb-6">
              Furthermore, we process your data if this is necessary to fulfill a legal obligation on the basis of Art. 6 para. 1 lit. c GDPR. Data processing may also be carried out on the basis of our legitimate interest according to Art. 6 para. 1 lit. f GDPR. Information on the relevant legal basis in each individual case is provided in the following paragraphs of this privacy policy.
            </p>

            <h2 className="text-2xl mb-4 mt-8">5. Contact</h2>
            
            <h3 className="text-xl mb-3">Contact by Email, Phone, or Fax</h3>
            <p className="mb-4">
              If you contact us by email, phone, or fax, your inquiry, including all resulting personal data (name, inquiry), will be stored and processed by us for the purpose of processing your request. We do not pass on this data without your consent.
            </p>
            <p className="mb-4">
              The processing of this data is based on Art. 6 para. 1 lit. b GDPR if your request is related to the fulfillment of a contract or is necessary for the implementation of pre-contractual measures. In all other cases, the processing is based on our legitimate interest in the effective processing of inquiries addressed to us (Art. 6 para. 1 lit. f GDPR) or on your consent (Art. 6 para. 1 lit. a GDPR) if this has been requested.
            </p>
            <p className="mb-6">
              The data you send to us via contact requests will remain with us until you request deletion, revoke your consent to storage, or the purpose for data storage no longer applies (e.g., after your request has been processed). Mandatory legal provisions – in particular legal retention periods – remain unaffected.
            </p>

            <h2 className="text-2xl mb-4 mt-8">6. Cookies and Tracking Technologies</h2>
            
            <h3 className="text-xl mb-3 mt-6">General Information on Cookies</h3>
            <p className="mb-4">
              This website uses cookies. Cookies are small text files and do not cause any damage to your device. They are stored either temporarily for the duration of a session (session cookies) or permanently (permanent cookies) on your device. Session cookies are automatically deleted after your visit ends. Permanent cookies remain stored on your device until you delete them yourself or an automatic deletion takes place through your web browser.
            </p>
            <p className="mb-4">
              In some cases, cookies from third-party companies may also be stored on your device when you enter our site (third-party cookies). These enable us or you to use certain services of the third-party company (e.g., cookies for processing payment services).
            </p>
            <p className="mb-6">
              Cookies have various functions. Numerous cookies are technically necessary, as certain website functions would not work without them (e.g., the shopping cart function or the display of videos). Other cookies can be used to evaluate user behavior or for advertising purposes.
            </p>

            <h3 className="text-xl mb-3">Cookies that are required to carry out the electronic communication process, to provide certain functions you have requested (e.g., for the shopping cart function), or to optimize the website (e.g., cookies for measuring web audience) (necessary cookies) are stored on the basis of Art. 6 para. 1 lit. f GDPR, unless another legal basis is specified.</h3>
            <p className="mb-4">
              The website operator has a legitimate interest in storing necessary cookies for the technically error-free and optimized provision of its services. If consent to the storage of cookies and comparable recognition technologies has been requested, processing is carried out exclusively on the basis of this consent (Art. 6 para. 1 lit. a GDPR and § 25 para. 1 TDDDG); consent can be revoked at any time.
            </p>
            <p className="mb-6">
              You can revoke your consent at any time via our cookie settings or directly here. Data processing that has taken place until the revocation remains unaffected by the revocation.
            </p>

            <h3 className="text-xl mb-3">Server Log Files</h3>
            <p className="mb-4">
              The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Browser type and version</li>
              <li>Operating system used</li>
              <li>Referrer URL</li>
              <li>Hostname of the accessing computer</li>
              <li>Time of server request</li>
              <li>IP address</li>
            </ul>
            <p className="mb-6">
              A combination of this data with other data sources is not carried out. The collection of this data is based on Art. 6 para. 1 lit. f GDPR. The website operator has a legitimate interest in the technically error-free presentation and optimization of its website – for this purpose, the server log files must be collected.
            </p>

            <h2 className="text-2xl mb-4 mt-8">7. Data Transfer to Third Countries</h2>
            <p className="mb-4">
              If we transfer data to third countries (i.e., countries outside the European Union (EU), the European Economic Area (EEW)) or if the transfer takes place in the context of the use of third-party services or the disclosure or transfer of data to third parties, this only takes place if it is necessary for the fulfillment of our (pre)contractual obligations, on the basis of your consent, due to a legal obligation, or on the basis of our legitimate interests.
            </p>
            <p className="mb-6">
              Subject to express consent or contractually required transfer, we only process or have data processed in third countries with a recognized level of data protection, contractual obligation through so-called standard contractual clauses of the EU Commission, in the presence of certifications or binding internal data protection regulations.
            </p>

            <h2 className="text-2xl mb-4 mt-8">8. Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>
                <strong>Information</strong> about your personal data stored by us (Art. 15 GDPR). In particular, you can request information about the purposes of processing, the category of personal data, the categories of recipients to whom your data has been or will be disclosed, the planned storage period, the existence of a right to rectification, deletion, restriction of processing or objection, the existence of a right to complain, the origin of your data if it was not collected by us, and the existence of automated decision-making including profiling and, if applicable, meaningful information about its details.
              </li>
              <li>
                <strong>Rectification</strong> of incorrect or completion of your data stored by us (Art. 16 GDPR).
              </li>
              <li>
                <strong>Deletion</strong> of your data stored by us, unless legal retention obligations or legal grounds for storing the data conflict (Art. 17 GDPR).
              </li>
              <li>
                <strong>Restriction of processing</strong> of your personal data (Art. 18 GDPR), if the accuracy of the data is contested by you, the processing is unlawful, but you refuse deletion and we no longer need the data, but you need it for the assertion, exercise, or defense of legal claims, or you have filed an objection to the processing pursuant to Art. 21 GDPR.
              </li>
              <li>
                <strong>Data portability</strong>, if we process your data on the basis of consent or a contract automatically (Art. 20 GDPR). You have the right to receive your data in a structured, common, and machine-readable format or to request the transfer to another controller.
              </li>
              <li>
                <strong>Objection</strong> to the processing of your personal data, if this is done on the basis of Art. 6 para. 1 lit. e or f GDPR and there are reasons that arise from your particular situation (Art. 21 GDPR). If personal data is processed by us for direct marketing purposes, you can object to the processing of your personal data for such advertising at any time.
              </li>
              <li>
                <strong>Revocation of your consent</strong> to us (Art. 7 para. 3 GDPR). This has the consequence that we may no longer continue the data processing based on this consent in the future.
              </li>
              <li>
                <strong>Complaint</strong> to a supervisory authority, in particular in the member state of your residence, your place of work, or the place of the alleged violation, if you believe that the processing of personal data concerning you violates the GDPR (Art. 77 GDPR).
              </li>
            </ul>

            <h3 className="text-xl mb-3 mt-6">Revocation of Your Consent to Data Processing</h3>
            <p className="mb-6">
              Many data processing operations are only possible with your express consent. You can revoke consent you have already given at any time. The legality of the data processing carried out until the revocation remains unaffected by the revocation.
            </p>

            <h3 className="text-xl mb-3">Right to Object to Data Collection in Special Cases and to Direct Advertising (Art. 21 GDPR)</h3>
            <p className="mb-4">
              IF DATA PROCESSING IS CARRIED OUT ON THE BASIS OF ART. 6 PARA. 1 LIT. E OR F GDPR, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA AT ANY TIME FOR REASONS ARISING FROM YOUR PARTICULAR SITUATION; THIS ALSO APPLIES TO PROFILING BASED ON THESE PROVISIONS.
            </p>
            <p className="mb-4">
              IF YOUR PERSONAL DATA IS PROCESSED FOR DIRECT MARKETING PURPOSES, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU FOR SUCH ADVERTISING; THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS RELATED TO SUCH DIRECT MARKETING.
            </p>
            <p className="mb-6">
              If you object to processing for direct marketing purposes, the processing of personal data for these purposes will be discontinued.
            </p>

            <h2 className="text-2xl mb-4 mt-8">9. Technical and Organizational Measures</h2>
            <p className="mb-4">
              We use technical and organizational measures to protect your personal data against loss, destruction, manipulation, and unauthorized access. Our security measures are continuously improved in line with technological developments.
            </p>
            <p className="mb-6">
              These measures include in particular the encryption of your data using SSL/TLS, access restrictions, regular backups, and training of our employees in handling personal data.
            </p>

            <h2 className="text-2xl mb-4 mt-8">10. Changes to This Privacy Policy</h2>
            <p className="mb-6">
              We reserve the right to adapt this privacy policy so that it always complies with current legal requirements or to implement changes to our services in the privacy policy, e.g., when introducing new services. The new privacy policy will then apply to your next visit.
            </p>

            <p className="mt-8 text-sm border-t pt-4">
              <strong>Last updated:</strong> January 2026<br />
              This privacy policy complies with the requirements of the GDPR, BDSG, TDDDG, and current legal provisions.
            </p>
          </>
        )
      }
    }
  };

  const currentContent = content[language][page === 'imprint' ? 'imprint' : 'privacy'];

  return (
    <div className="min-h-screen bg-white font-mono">
      {/* Navigation */}
      <div className="absolute top-8 left-8 z-50">
        <Link 
          to="/"
          className="px-6 py-2 border-2 border-black text-black hover:bg-black hover:text-white transition-all font-mono text-lg flex items-center gap-2"
        >
          <ArrowLeft size={20} />
          {language === 'de' ? 'Zurück' : 'Back'}
        </Link>
      </div>

      <div className="container mx-auto px-4 py-24">
        <h1 className="text-4xl font-mono mb-8">{currentContent.title}</h1>
        <div className="prose prose-lg max-w-none">
          <div className="font-mono [&_h2]:font-mono [&_h3]:font-mono [&_h4]:font-mono [&_p]:font-mono [&_ul]:font-mono [&_li]:font-mono">
            {currentContent.content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legal; 